// Product catalog — must stay in sync with api/data/products.json.
// JPY pricing for JP-primary store. Prices are placeholders pending real
// supply-chain quote (see commit history for conversion notes).

import type { ProductVariant } from "../types";

export const PRODUCTS: ProductVariant[] = [
  // ─── Glass Photo Frame (main / entry product) ──────────────────
  // Sublimation-ready glass, 230×180×5mm tabletop size. Gift-box ready.
  // (Customer-facing name unified to "Glass Photo Frame / ガラスフォトフレーム"
  // across the whole site — was "Photo Panel" — 2026-06-17.)
  {
    type: "photo_panel",
    printifyId: 0,
    label: "Glass Photo Frame",
    subtitle: "Tabletop sublimation glass photo frame",
    material: "Sublimation-ready glass, high-gloss photo finish",
    features: [
      "230×180mm tabletop display size",
      "Sublimation-printed photographic finish — sharp & vibrant",
      "5 mm glass — sits on a desk, shelf, or display cabinet",
      "Easel stand included for upright display",
      "Gift-box ready — a keepsake to celebrate your dog",
    ],
    sizes: [
      { label: "230×180mm", width: 7.1, height: 9.1, printifyCost: 5.50, retailPrice: 4980 },
    ],
  },

  // ─── Gallery Canvas (Stretched, 0.75") ─────────────────────────
  // Cotton-polyester composite on radiata pine stretcher bars.
  // hidden: only Photo Panel is on sale for now (owner decision
  // 2026-06-12) — flip to false/remove to re-list.
  {
    hidden: true,
    type: "gallery_canvas",
    printifyId: 937,
    label: "Gallery Canvas",
    subtitle: "Stretched, 0.75\" depth",
    material: "Cotton-polyester canvas composite (333 g/m²) on radiata pine stretcher bars",
    features: [
      "0.75\" gallery-wrap depth",
      "Proprietary matte coating for vibrant prints",
      "Back hanging hardware included",
      "Eco-friendly FSC-certified frame",
    ],
    sizes: [
      { label: '12×16"', width: 12, height: 16, printifyCost: 18.00, retailPrice: 10800 },
      { label: '16×20"', width: 16, height: 20, printifyCost: 22.00, retailPrice: 13800 },
      { label: '18×24"', width: 18, height: 24, printifyCost: 28.00, retailPrice: 16800 },
      { label: '24×36"', width: 24, height: 36, printifyCost: 44.00, retailPrice: 27800 },
    ],
  },

  // ─── Framed Canvas ─────────────────────────────────────────────
  // Cotton-polyester canvas in a pinewood frame. 2 colors for launch.
  // hidden: only Photo Panel is on sale for now — see note above.
  {
    hidden: true,
    type: "framed_canvas",
    printifyId: 944,
    label: "Framed Canvas",
    subtitle: "Pinewood frame, multiple colors",
    material: "Cotton-polyester canvas with proprietary coating in a pinewood frame",
    features: [
      "Pinewood frame (2 color options)",
      "Special proprietary coating for lasting colors",
      "Sawtooth hanging hardware pre-attached",
      "FSC-certified sustainable materials",
    ],
    frameColors: ["Black", "Walnut"],
    sizes: [
      { label: '12×16"', width: 12, height: 16, printifyCost: 22.08, retailPrice: 13800 },
      { label: '16×20"', width: 16, height: 20, printifyCost: 28.00, retailPrice: 16800 },
      { label: '18×24"', width: 18, height: 24, printifyCost: 34.00, retailPrice: 21500 },
      { label: '24×36"', width: 24, height: 36, printifyCost: 50.00, retailPrice: 30800 },
    ],
  },

];

/** Look up a product variant by type. */
export function getProduct(type: ProductVariant["type"]): ProductVariant {
  return PRODUCTS.find((p) => p.type === type)!;
}
